// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 1em;
}
.dashboard .header {
  display: flex;
  background-color: #f0f8ff;
  padding: 0.5em;
  font-size: 2em;
  border: 1px solid lightgray;
  border-radius: 4px 4px 0 0;
  border-bottom: 0;
}
.dashboard .header img.icon {
  height: 44px;
  max-width: 200px;
  width: auto;
  padding-right: 20px;
}
.dashboard .header .title {
  flex: 1;
  color: black;
}
.dashboard .header .actions {
  padding: 0 10px;
}
.dashboard .grid {
  flex: 1;
  padding: 0.5em;
  border: 1px solid lightgray;
  border-radius: 0 0 4px 4px ;
  display: grid;
  column-gap: 0.5em;
  row-gap: 0.5em;
  justify-items: stretch;
  grid-auto-rows: 1fr;
}
`, "",{"version":3,"sources":["webpack://./src/Component/Dashboard/Dashboard.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AACF;AALA;EAOI,aAAA;EACA,yBAAA;EACA,cAAA;EACA,cAAA;EACA,2BAAA;EACA,0BAAA;EACA,gBAAA;AACJ;AAdA;EAgBM,YAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;AACN;AApBA;EAuBM,OAAA;EACA,YAAA;AAAN;AAxBA;EA4BM,eAAA;AADN;AA3BA;EAiCI,OAAA;EACA,cAAA;EACA,2BAAA;EACA,2BAAA;EACA,aAAA;EACA,iBAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AAHJ","sourcesContent":[".dashboard {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 1em;\n\n  .header {\n    display: flex;\n    background-color: #f0f8ff;\n    padding: 0.5em;\n    font-size: 2em;\n    border: 1px solid lightgray;\n    border-radius: 4px 4px 0 0;\n    border-bottom: 0;\n\n    img.icon {\n      height: 44px;\n      max-width: 200px;\n      width: auto;\n      padding-right: 20px;\n    }\n\n    .title {\n      flex: 1;\n      color: black;\n    }\n\n    .actions {\n      padding: 0 10px;\n    }\n  }\n\n  .grid {\n    flex: 1;\n    padding: 0.5em;\n    border: 1px solid lightgray;\n    border-radius: 0 0 4px 4px ;\n    display: grid;\n    column-gap: 0.5em;\n    row-gap: 0.5em;\n    justify-items: stretch;\n    grid-auto-rows: 1fr;\n  }\n}\n\n@drawer-width: 600px;@primary-color: #137CBD;@info-color: #137CBD;@success-color: #0F9960;@warning-color: #D9822B;@error-color: #DB3737;@link-color: #137CBD;@font-size-base: 14px;@heading-color: rgba(0, 0, 0, 0.85);@text-color: rgba(0, 0, 0, 0.65);@text-color-secondary: rgba(0, 0, 0, .45);@disabled-color: rgba(0, 0, 0, .25);@border-radius-base: 0px;@border-color-base: #d9d9d9;@box-shadow-base: 0 2px 8px rgba(0, 0, 0, 0.15);"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
